import { render, staticRenderFns } from "./CommentCreateComponent.vue?vue&type=template&id=694395e0"
import script from "./CommentCreateComponent.vue?vue&type=script&lang=js"
export * from "./CommentCreateComponent.vue?vue&type=script&lang=js"
import style0 from "./CommentCreateComponent.vue?vue&type=style&index=0&id=694395e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports